import L from 'leaflet';
import '../../styles/CondensedAttribution.scss'; // import from top-level styles because we don't want modules here

export const CondensedAttribution = L.Control.Attribution.extend({
    addAttribution(text: string) {
        this._attributions.set(text, true);
        this._update();
        return this;
    },
    onAdd(map: L.Map) {
        this._attributions = new Map<string, boolean>();
        this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
        map.attributionControl = this;
        L.DomEvent.disableClickPropagation(this._container);

        map.eachLayer(layer => layer.getAttribution() && this.addAttribution(layer.getAttribution()));
        map.on('layeradd', this._handleLayerAddition.bind(this));

        this._update();

        return this._container;
    },
    onRemove(map: L.Map) {
        map.off('layeradd', this._handleLayerAddition);
    },
    removeAttribution(text: string) {
        this._attributions.delete(text);
        this._update();
        return this;
    },
    setPrefix(prefix: string | false) {
        this.options.prefix = prefix;
        this._update();
        return this;
    },
    _handleLayerAddition($e: L.LayerEvent) {
        const attr = $e.layer.getAttribution();
        if (attr) {
            this.addAttribution(attr);
            $e.layer.once('remove', () => this.removeAttribution(attr));
        }
    },
    _update() {
        this._container.innerHTML = `<div class="attributions">${
            this.options.prefix || ''
        }${
            this.options.prefix ? ' <span aria-hidden="true">|</span> ' : ''
        }${
            Array.from(this._attributions.keys()).join(', ')
        }</div>`;
    },
});
L.Map.addInitHook(function() {
    new CondensedAttribution().addTo(this);
});
